export default {"src":"https://euapp.enumerate.ai/_next/static/media/colab.aa9444ec.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};